import {useMemo} from "react";
import {
    autoUpdate,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
    useRole,
    useTransitionStatus
} from "@floating-ui/react";

const useSidebarSettings = (isOpen: boolean, setIsOpen: (isOpen: boolean) => void) => {
    /**
     * Warning: `context` changes too frequently - do not return it or use in the dependency array.
     * Otherwise, it causes "Uncaught RangeError: Maximum call stack size exceeded".
     */
    const { refs, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        whileElementsMounted: autoUpdate,
    });

    // This hook manages the animation states for CSS transitions.
    const {isMounted, status} = useTransitionStatus(context, {
        duration: 300,
    });

    // --- Interaction Hooks ---
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);

    // Merge all interaction hooks into props for the elements.
    const {getReferenceProps,getFloatingProps} = useInteractions([
        click,
        dismiss,
        role,
    ]);

    return useMemo(() => (
        {
            floating: { refs },
            transitionStatus: { isMounted, status },
            interactions: { getReferenceProps, getFloatingProps },
        }
    ), [
        refs,
        isMounted,
        status,
        getReferenceProps,
        getFloatingProps,
    ]);
};

export default useSidebarSettings;